// extracted by mini-css-extract-plugin
export var associationsWrapper = "index-module--associationsWrapper--7d128";
export var centerImg = "index-module--centerImg--4940c";
export var copyrightWrapper = "index-module--copyrightWrapper--69da9";
export var copyrightWrapperMobile = "index-module--copyrightWrapperMobile--d6c74";
export var divider = "index-module--divider--5edf9";
export var footerContact = "index-module--footerContact--cd010";
export var footerCopyright = "index-module--footerCopyright--e6625";
export var footerNavWrapper = "index-module--footerNavWrapper--4c7f1";
export var footerSocial = "index-module--footerSocial--a5415";
export var kczooBreadcrumbs = "index-module--kczooBreadcrumbs--b57d9";
export var kczooFooter = "index-module--kczooFooter--3ffc6";
export var mainRow = "index-module--mainRow--04f55";
export var moveLinks = "index-module--moveLinks--ac947";
export var navSpacing = "index-module--navSpacing--1a2c7";